import CtaCard from "@/components/ctaCard";
import { CTA_CONSTANTS } from "./constants";

const CTA = () => {
  return <CtaCard {...CTA_CONSTANTS} />;
};

export default CTA;
